
import VisitorCounter from './VisitorCounter';

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white py-10">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          <div>
            <div className="flex items-center space-x-2 mb-3">
              <img 
                alt="DJ Jean Logo" 
                className="w-8 h-8 rounded-full object-cover" 
                src="https://static.readdy.ai/image/0179d60eb192a4383e7134d41ff99ed6/7d0c5962630ec0c61617194cca58b51e.jfif"
              />
              <h3 className="text-lg font-bold">DJ Jean</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Som e iluminação profissional para eventos inesquecíveis em Blumenau e região.
            </p>
          </div>
          
          <div className="text-center md:text-left">
            <h4 className="text-base font-bold mb-3">Links Rápidos</h4>
            <ul className="space-y-1">
              <li>
                <button 
                  onClick={() => scrollToSection('servicos')}
                  className="text-gray-400 hover:text-white cursor-pointer text-sm"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('festa')}
                  className="text-gray-400 hover:text-white cursor-pointer text-sm"
                >
                  Alegria
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('depoimentos')}
                  className="text-gray-400 hover:text-white cursor-pointer text-sm"
                >
                  Depoimentos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contato')}
                  className="text-gray-400 hover:text-white cursor-pointer text-sm"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-base font-bold mb-3">Contato Rápido</h4>
            <div className="space-y-2">
              <p className="text-gray-400 flex items-center text-sm">
                <i className="ri-phone-line mr-2"></i>
                (47) 8488-3371
              </p>
              <p className="text-gray-400 flex items-center text-sm">
                <i className="ri-mail-line mr-2"></i>
                need.informatica@yahoo.com.br
              </p>
              <p className="text-gray-400 flex items-center text-sm">
                <i className="ri-map-pin-line mr-2"></i>
                Blumenau - SC e região
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm text-center sm:text-left">
            © 2025 DJ Jean – Todos os direitos reservados. | Desenvolvido com tecnologia Need Panfletagem e Divulgações
          </p>
          <VisitorCounter />
        </div>
      </div>
    </footer>
  );
}
